import { cva } from 'class-variance-authority';

const box = cva('min-h-fit overflow-hidden rounded-lg', {
  variants: {
    p: {
      none: '',
      10: 'p-10',
      undefined: 'p-6',
    },
    bg: {
      gray: 'bg-gray-100',
      undefined: 'bg-white',
    },
  },
});

export default box;
